module.exports = "/assets/Inter-Medium.eec0ea57.woff";